module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABSklEQVQ4ja3TT0tUYRQG8N+84bSIFq2FQpdONBHC4LoWI/YFdC2mKIjfoE9Q6s6ybV8gFBfjfgrREUahTeDCfQtF8v/inpuXYUYNOnA4vM99nofznvfckvdbOmIIkxjFQGC/sIFV7BfJpYJBGR8wg9TpGnGJz1jAiQKxjDXM4hzLGMHjyJHAzvEO30Lz1+Aj3uAQNcyjiaPIZmC14LyObiVUwvUUb9EqtHzQcYUWxvAH06ikGNgDrHSI4WmXOeziU2gmE+rx4WsXcq/IufWEwThs/4PBTtTBXs+Vx29cRRbn0Rf1NMmWBF51MXiCUuSzAv486kGSbRhM3Nn4TYxHbSR8wQWmUL2H+IXs2S+wmtCWPeFD2Ta+vEVcxXpwV9DOh7iABvrxHYsYxqPI4cB+BGczNP/vZyJb5bm44xJ+4gzH2AusKlvhk1x0DcqwS8ZrTukDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/router-detail-icon2.png
// module id = tvxf
// module chunks = 1